import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import './HeaderLink.css';

const HeaderLink = ({ children, className, to }) => (
  <Link
    className={clsx('HeaderLink', {
      [className]: className,
    })}
    to={to}
  >
    {children}
  </Link>
);

export default HeaderLink;
